import { oz } from '@weft/utils';
import { CustomerOverviewSchema } from './customer-overview-schema';

export const GetCustomersOverviewsResponseSchema = oz.object({
  customers: oz.array(CustomerOverviewSchema),
  countedFilteredCustomers: oz.number().nonnegative(),
  countedTotalCustomers: oz.number().nonnegative(),
  countedActiveCustomers: oz.number().nonnegative(),
}).openapi('GetCustomersOverviewsResponse');

export type GetCustomersOverviewsResponse = oz.infer<typeof GetCustomersOverviewsResponseSchema>;